import React, { useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import { NavLink } from "react-router-dom";
import { useTheme } from "@material-ui/core/styles";
import grid from "../../../assets/icons/grid.png";
import user from "../../../assets/icons/user.png";
import { CgLogOut } from "react-icons/cg";
import activeSettings from "assets/icons/activeSettings.svg";
import Dashboard from "assets/icons/Dashboard.svg";

import appointment from "assets/icons/appointmentList.svg";
import activeAvailable from "assets/icons/activeAvailable.svg";
import activeAppointmentList from "assets/icons/activeAppointmentList.svg";
import { logout } from "service/helpers/utilities";

import activeProfile from "assets/icons/activeProfile.svg";
// import appointmentlist from "../../../assets/icons/appointmentList.png";

import logo from "../../../assets/images/meradoc.png";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { restrictionURL } from "action/home";


import "./style.scss";

const navLink = [
  {
    to: "/doctor/dashboard",
    label: "Dashboard",
    iconName: Dashboard,
    activeIcon: Dashboard,
  },

  {
    to: `/doctor/appointment-list`,
    label: "Appointment list",
    iconName: appointment,
    activeIcon: appointment,
  },
  {
    to: "/doctor/availability",
    label: "Availability",
    iconName: activeAvailable,
    activeIcon: activeAvailable,
  },

  // {
  //   to: "/doctor/consultation-view",
  //   label: "Consultation View",
  //   iconName: activeAvailable,
  //   activeIcon: activeAvailable,
  // },
];

const subLink = [
  {
    to: "/doctor/my-profile",
    label: "My Profile",
    iconName: activeProfile,
    activeIcon: activeProfile,
  },

  {
    to: "/doctor/settings",
    label: "Settings",
    iconName: activeSettings,
    activeIcon: activeSettings,
  },
];

function Sidebar({ classes, window }) {
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const appState=useSelector(state=>state.user)
  console.log(appState,"appState")
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const location = useLocation();
  console.log(location.pathname);
  const dispatch = useDispatch();
  const logoutUser = () => {
    logout()
    dispatch(restrictionURL("", true))
  }

  const drawer = (
    <div>
      <div className={classes.toolbar}>
        <div className="px-3 py-4">
          <img src={logo} alt="logo" width="80%"></img>
        </div>
      </div>
      <List className={classes.nav} style={{ textDecoration: "none" }}>
        {React.Children.toArray(
          navLink.map(
            ({ to, label, iconName, activeIcon, nestedChild }, index) => (
              <>
                <NavLink
                  key={index}
                  to={to}
                  onClick={
                    to !== "/something" ? () => setActiveIndex(index) : ""
                  }
                  style={{
                    textDecoration: "none",
                  }}
                >
                  <div
                    style={{
                      borderRight:
                        location.pathname === to ? "5px solid #0E69C2" : null,
                    }}
                  >
                    <ListItem
                      button
                      className={
                        location.pathname === to ? "active-div" : "inActive-div"
                      }
                    >
                      <ListItemText>
                        <div className="d-flex">
                          <span className="mr-4 ml-md-2">
                            {location.pathname === to ? (
                              <img src={activeIcon} />
                            ) : (
                              <img src={iconName} />
                            )}
                          </span>

                          <span
                            className={
                              location.pathname === to
                                ? "activeBar"
                                : "inActiveBar"
                            }
                          >
                            {label}
                          </span>
                        </div>
                      </ListItemText>
                    </ListItem>
                  </div>
                </NavLink>
              </>
            )
          )
        )}
      </List>
      <hr className="mx-3" />
      <div>
        <List className={classes.nav} style={{ textDecoration: "none" }}>
          {React.Children.toArray(
            subLink.map(
              ({ to, label, iconName, activeIcon, nestedChild }, index) => (
                <>
                  <NavLink
                    key={index}
                    to={to}
                    onClick={
                      to !== "/something" ? () => setActiveIndex(index) : ""
                    }
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      style={{
                        borderRight:
                          location.pathname === to ? "5px solid #0E69C2" : null,
                      }}
                    >
                      <ListItem
                        button
                        className={
                          location.pathname === to
                            ? "active-div"
                            : "inActive-div"
                        }
                      >
                        <div>
                          <ListItemText>
                            <div className="d-flex">
                              <span className="mr-4 ml-md-2">
                                {location.pathname === to ? (
                                  <img src={activeIcon} />
                                ) : (
                                  <img src={iconName} />
                                )}
                              </span>

                              <span
                                className={
                                  location.pathname === to
                                    ? "activeBar"
                                    : "inActiveBar"
                                }
                              >
                                {label}
                              </span>
                            </div>
                          </ListItemText>
                        </div>
                      </ListItem>
                    </div>
                  </NavLink>
                </>
              )
            )
          )}
        </List>
        <div className="px-2">
          <div className="d-flex cursor-pointer" onClick={() => logoutUser()}>
            <CgLogOut className="mx-3" size={25} />
            <span className="inActiveBar"> Logout</span>
          </div>
        </div>
      </div>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <nav className={`${classes.drawer} d-none`} aria-label="mailbox folders">
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
    </>
  );
}

export default Sidebar;
